export default {
  overFlowMenu: {
    tooltip: 'Dodatkowe funkcje',
    export: 'Eksportuj znaczenia niestandardowe',
    import: 'Importuj niestandardowe znaczenia',
  },
};
